import { render, staticRenderFns } from "./AvatarManagerModal.vue?vue&type=template&id=a8a12c58&"
import script from "./AvatarManagerModal.vue?vue&type=script&lang=js&"
export * from "./AvatarManagerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports